import React, {useState, useEffect} from 'react';
import {HeaderContentBodyNotificaciones} from './HeaderContentBodyNotificaciones';
import {MiNotificacion} from './MiNotificacion';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ContentBodyNotificaciones = () => {
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	// noLeidas leidas todas
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);

	let listaNotificacionesNoLeidas = Usuario.listaNoLeidas;
	let listaNotificacionesLeidas = Usuario.listaLeidas;

	return (
		<div className='ContentBodyMiNotificaciones'>
			<HeaderContentBodyNotificaciones
				TipoNotificaciones={TipoNotificaciones}
				setTipoNotificaciones={setTipoNotificaciones}
				numeroNotificaciones={[
					listaNotificacionesNoLeidas.length,
					listaNotificacionesLeidas.length,
				]}
			/>
			{TipoNotificaciones[0] === 'buttonNotificacionesActive'
				? listaNotificacionesNoLeidas.map((notificacion, key) => (
						<MiNotificacion
							nombreUsu={notificacion.nombreUsu}
							imagenUsu={notificacion.imagenUsu}
							mensaje={notificacion.mensaje}
							hora={notificacion.hora}
						/>
				))
				: TipoNotificaciones[1] === 'buttonNotificacionesActive'
				? listaNotificacionesLeidas.map((notificacion, key) => (
							<MiNotificacion
								nombreUsu={notificacion.nombreUsu}
								imagenUsu={notificacion.imagenUsu}
								mensaje={notificacion.mensaje}
								hora={notificacion.hora}
							/>
				))
				: null}
		</div>
	);
};
